/**
 * Pre-compiled localized messages for ModalPage component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import modalPageMessages_en from "./intl/en";
import modalPageMessages_de from "./intl/de";
import modalPageMessages_es from "./intl/es";
import modalPageMessages_fr from "./intl/fr-FR";
import modalPageMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const modalPageMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(modalPageMessages_en),
  de: normalizeMessages(modalPageMessages_de),
  es: normalizeMessages(modalPageMessages_es),
  "fr-FR": normalizeMessages(modalPageMessages_fr),
  "pt-BR": normalizeMessages(modalPageMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for ModalPage component
 */
export type ModalPageMessageKey = "backButton";
